export class NumberChildOutputData {
  public variable: string;
  public joiningOperand: string;
  public variablen: string;
  public childItem: boolean = false;
  public parentName: string;
}
